// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_iA","breadcrumbs__separator":"_iB","breadcrumbs__item":"_iC","options__subject":"_iD","options__grade":"_iE"};